/* eslint-disable react-hooks/exhaustive-deps */
import { FlightPoint, ITripTrackingTrack, ITripTrackingTrip } from '@common/models';
import FlightRoute from '@components/checkIn/FlightRoute';
import Divider from '@components/general/Divider';
import TripTrackMapTracking from '@components/tripTrack/TripTrackMapTracking';
import { AppAction, IAppAction } from '@misc/Action';
import { IAppState } from '@misc/State';
import { Action, getTrack, getTrip } from '@service/proxy';
import Translate from '@service/Translate';
import { formatToDateTime, getAirport } from '@utilize/Format';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import imageError from "@assets/images/payment-failed-icon.svg";
import { renderLoading } from './BoardingPass';
import Navigation from '@components/general/Navigation';
import { Direction } from '@common/constans';

interface ITripTrackProps { }

let trackInterval: NodeJS.Timeout;
const TripTrack: FC<ITripTrackProps> = () => {
    const { tr } = Translate;
    const dispatch = useDispatch();
    const query = new URLSearchParams(useLocation().search);
    const { routes } = useSelector((state: IAppState) => ({ routes: state.routes }));
    const [trip, setTrip] = useState<ITripTrackingTrip>();
    const [track, setTrack] = useState<ITripTrackingTrack>({});
    const { errors } = useSelector((state: IAppState) => ({
        errors: state.errors,
    }));

    useEffect(() => {
        if (routes.length) {
            const flightNumber = query.get("flight") || "";
            const referenceId = query.get("ticket") || "";
            const passengerId = query.get("id") || "";
            getTrip(Action.POST, { data: { flightNumber, referenceId, passengerId } })
                .then((tripRes) => {
                    setTrip(tripRes.content);
                    if (tripRes.content.id)
                        trackInterval = setInterval(() => {
                            getTrack(Action.POST, { data: { flightNumber: tripRes.content.id, referenceId, passengerId } })
                                .then((trackRes) => setTrack(trackRes.content))
                                .catch(() => clearInterval(trackInterval))
                        }, 15000);
                })
                .catch(e => dispatch<IAppAction>({ type: AppAction.Errors, payload: { errors: e.messages || [] } }))
                .finally(() => {
                })
        }
    }, [routes]);

    useEffect(() => {
        trip?.trail?.unshift(track);
        setTrip(trip);
    }, [track]);

    return (


        errors.length ?
            <main className="trip-track error">
                <article className="trip-track-title">
                    <img src={imageError} alt="imageError" />
                    {errors?.map((error, index) => <span key={index}>{tr(error.code)}</span>)}
                </article>
            </main>
            :
            <div className="trip-track">
                <div className="trip-track-header">
                    {trip ? <span className="en trip-track-passenger-name trim">{`${trip?.traveler?.prefix}. ${trip?.traveler?.firstName} ${trip?.traveler?.lastName}`}</span> : renderLoading().header}
                </div>
                <div className="trip-track-content">
                    <FlightRoute flightSegment={trip?.flightSegment || {}} />
                    <Divider mode="perforation" orientation="horizontal" />
                    <div className="trip-track-duration">
                        <div className="trip-track-duration-section">
                            <div className="trip-track-duration-section-item">
                                <div className="trip-track-duration-section-item-title">{tr("trip_track_schedule_departure_time")}</div>
                                <div className="trip-track-duration-section-item-value">{trip?.flightSegment?.departureDateTime ? formatToDateTime(trip?.flightSegment?.departureDateTime || 0, { format: "H:i" }) : renderLoading().numberBox}</div>
                            </div>
                            {trip?.flightSegment?.actualDepartureTime ? <div className="trip-track-duration-section-item">
                                <div className="trip-track-duration-section-item-title">{tr("trip_track_actual_departure_time")}</div>
                                <div className="trip-track-duration-section-item-value">{trip?.flightSegment?.actualDepartureTime ? formatToDateTime(trip?.flightSegment?.actualDepartureTime || 0, { format: "H:i" }) : renderLoading().numberBox}</div>
                            </div> : <template />}
                        </div>
                        <Divider mode="perforation" orientation="vertical" />
                        <div className="trip-track-duration-section">
                            <div className="trip-track-duration-section-item">
                                <div className="trip-track-duration-section-item-title">{tr("trip_track_schedule_arrival_time")}</div>
                                <div className="trip-track-duration-section-item-value">{trip?.flightSegment?.arrivalDateTime ? formatToDateTime(trip?.flightSegment?.arrivalDateTime || 0, { format: "H:i" }) : renderLoading().numberBox}</div>
                            </div>
                            {trip?.flightSegment?.estimatedArrivalTime ? <div className="trip-track-duration-section-item">
                                <div className="trip-track-duration-section-item-title">{tr("trip_track_estimated_arrival_time")}</div>
                                <div className="trip-track-duration-section-item-value">{trip?.flightSegment?.estimatedArrivalTime ? formatToDateTime(trip?.flightSegment?.estimatedArrivalTime || 0, { format: "H:i" }) : renderLoading().numberBox}</div>
                            </div> : <template />}
                        </div>
                    </div>
                    <Divider mode="default" orientation="horizontal" />
                    {/* <TripTrackProgressBar />
                <Divider mode="perforation" orientation="horizontal" /> */}
                    {
                        <TripTrackMapTracking
                            trip={trip}
                            flightPosition={trip?.trail?.length ? (trip?.trail as ITripTrackingTrack[])[0] : {}}
                            flightSegment={trip?.flightSegment || {}}
                        />
                    }
                    {(errors.length || !trip?.id) ? <template /> : <div className="trip-track-routing">
                        <Navigation
                            location={
                                {
                                    lat: new FlightPoint(trip?.flightSegment?.destination!).getDefaultTerminal(Direction.Arrival, trip.flightSegment?.origin?.code || "")?.location?.latitude ?? getAirport(trip?.flightSegment?.destination?.code).latitude!,
                                    lng: new FlightPoint(trip?.flightSegment?.destination!).getDefaultTerminal(Direction.Arrival, trip.flightSegment?.origin?.code || "")?.location?.longitude! ?? getAirport(trip?.flightSegment?.destination?.code).longitude!
                                }
                            }
                            height='40px'
                            variant="contained"
                            color="primary"
                            text={tr("routing_to", "airport_name", "destination")}
                            icon="icon-airport-arrival"
                            target="_blank"
                        />
                    </div>}
                </div>
            </div>
    )
}

export default TripTrack;